import { BphStopModel } from './BphTypes';

export class StopsMapDisplayPool {
    private readonly stops: BphStopModel[] = [];
    private displayDirectionStops = false;

    constructor(_helper: any) {
        // helper preserved for compatibility
    }

    public add(stop: BphStopModel) {
        this.stops.push(stop);
    }

    public select(_stop: BphStopModel | null) {
        // logic intentionally omitted
    }

    public empty() {
        this.stops.length = 0;
    }

    public switchDirectionStops(value: boolean) {
        this.displayDirectionStops = value;
    }

    public setDirectionStops(stops: BphStopModel[]) {
        this.empty();
        for (const s of stops) {
            this.add(s);
        }
    }

    public get isDisplayDirectionStops(): boolean { return this.displayDirectionStops; }
}
